export default __webpack_public_path__ + "static/media/Girdle of Clawing Might.30ae3aa4.jpg";